import React from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    Row,
    Col
} from 'reactstrap';
import { connect } from 'react-redux';
import ArchiveHeader from '../components/ArchiveHeader';
import ArchiveSidebar from '../components/ArchiveSidebar';
import { handleResponse } from '../../helpers/handleresponse';
import ErrorBoundary from '../../hoc/ErrorBoundry';
import { authHeader } from '../../helpers/authHeader';
import ArchiveContent from './ArchiveContent';
import '../style/Archive.css';
import { securityHelper } from '../../helpers/securityHelper';
import UploadingInfo from '../components/UploadInfo';
import { archiveConstants } from '../contstants/archive.contstants';
import SystemLabel from '../../system/SystemLabel/SystemLabel';
import UnsplashPlugin from '../components/UnsplashPlugin';
import ImageCropper from '../plugins/ImageCropper';
import { cmsActions } from '../../store/actions/cms/cms.action';
import { sourceTypes } from '../../constants/cms/sourceType';

class ArchiveContainer extends React.Component {
    state = {
        files: [],
        isOpen: false,
        filtered: null,
        uploadingInfo: null,
        selectedFile: null,
        unsplashFile: null,
        isUploading: false,
        storageUsage: 0,
        isCompleted: false,
        showLaunchBtn: true,
        fontEnabled: false,
        display: archiveConstants.CLIENT_STORAGE,
        useCropper: false,
        filterType: archiveConstants.IMAGE

    }
    componentDidMount() {
        this.download();
        if (this.props.cms.enviroment !== sourceTypes.EMAIL && this.props.cms.enviroment !== sourceTypes.PAGE) {
            this.props.dispatch(cmsActions.blockDeselect(true))
        }

        this.setState({
            isOpen: this.props.isOpen,
            showLaunchBtn: this.props.showLaunchBtn !== undefined ?
                this.props.showLaunchBtn :
                this.state.showLaunchBtn,
            fontEnabled: this.props.fontEnabled && this.props.fontEnabled === true ? true : false,
        }, () => {
            if (this.state.fontEnabled) {
                this.navigate(archiveConstants.CLIENT_STORAGE, archiveConstants.FONT);
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { showLaunchBtn } = this.props;
        if ((!showLaunchBtn ? this.props.isOpen : this.state.isOpen) && this.props.cms.deselectionBlocked == false) {
            this.props.dispatch(cmsActions.blockDeselect(true))
        }
    }
    toggle = () => {
        const { toggle } = this.props;

        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }), () => {
            if (toggle && typeof toggle === 'function') {
                this.props.toggle();
                setTimeout(() => this.props.dispatch(cmsActions.blockDeselect(false)), 2000)
            }
        });
    }
    onUseSelected = () => {
        const { onUseSelected, toggle } = this.props;
        const { selectedFile } = this.state;
        if (onUseSelected && typeof onUseSelected === 'function') {
            if (selectedFile.type.includes('font/')) {
                let fontName = selectedFile.name.substring(selectedFile.name.lastIndexOf('/') + 1, selectedFile.name.indexOf('.'));
                this.props.onUseSelected(fontName);
                return;
            }
            this.props.onUseSelected(selectedFile.url);
            setTimeout(() => this.props.dispatch(cmsActions.blockDeselect(false)), 2000)
            this.props.toggle();
        }
    }
    navigate = (dt, ft) => {
        this.setState({
            display: dt,
            filterType: ft,
            unsplashFile: null,
            selectedFile: null
        });
    }
    onUnsplashDownload = (unsplashFile) => {
        this.setState({ display: archiveConstants.CLIENT_STORAGE, filterType: archiveConstants.IMAGE });
        const fileInfo = {
            name: 'unsplash_image_' + securityHelper.createGuid(),
            size: 0,
            type: 'image/jpeg',
            file: unsplashFile.urls.raw
        }
        const requestOptions = {
            method: "POST",
            headers: authHeader({ "Content-Type": "application/json" }),
        };
        this.setState({ uploadingInfo: fileInfo, isUploading: true });
        let queryStr = "";
        if (window.location.search) {
            queryStr = window.location.search + "&url=" + encodeURIComponent(unsplashFile.urls.raw)
        }
        else {
            queryStr = "?url=" + encodeURIComponent(unsplashFile.urls.raw)
        }
        fetch(`./api/files/unsplash` + queryStr, requestOptions)
            .then(handleResponse)
            .then(file => {
                this.setState({
                    isCompleted: true,
                    unsplashFile: null,
                    selectedFile: { ...file },
                    storageUsage: this.state.storageUsage + file.size,
                    files: file !== undefined && file !== null && [Object.assign({}, { ...file }), ...this.state.files]
                }, () => {
                    this.setState({
                        isUploading: false,
                        uploadingInfo: null,
                    })
                });
            })
            .catch(err => {
                console.log(err.message);
            });
    }
    onUpload = (e) => {
        const file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (reader.result) {
                const fileInfo = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    file: reader.result
                }
                const requestOptions = {
                    method: "POST",
                    headers: authHeader({ "Content-Type": "application/json" }),
                    body: JSON.stringify(fileInfo)
                };
                this.setState({ uploadingInfo: fileInfo, isUploading: true });
                fetch(`./api/files/` + window.location.search, requestOptions)
                    .then(handleResponse)
                    .then(file => {
                        this.setState({
                            storageUsage: this.state.storageUsage + file.size,
                            selectedFile: Object.assign({}, { ...file }),
                            files: file !== undefined && file !== null && [Object.assign({}, { ...file }), ...this.state.files]
                        }, () => {
                            this.setState({
                                isUploading: false,
                                uploadingInfo: null,
                            })
                            if (file.type.includes('font/')) {
                                if (this.state.fontEnabled) {
                                    let fontName = this.state.selectedFile.name.substring(
                                        this.state.selectedFile.name.lastIndexOf('/') + 1,
                                        this.state.selectedFile.name.indexOf('.'));

                                    this.props.onFontUpload(fontName, file.url);

                                }
                                this.navigate(archiveConstants.CLIENT_STORAGE, archiveConstants.FONT);
                            }
                        });
                    })
                    .catch(err => {
                        console.error(err.message);
                    });
            }
        }
    }
    onDeleteFile = () => {
        let filePath = this.state.selectedFile.name;
        const requestOptions = {
            method: "DELETE",
            headers: authHeader({ "Content-Type": "application/json" })
        };
        filePath = filePath.substring(filePath.lastIndexOf('/') + 1);
        fetch(`./api/files/${filePath}` + window.location.search, requestOptions)
            .then(handleResponse)
            .then(_ => {
                const files = Array.from(this.state.files);
                const indexToRemove = files.indexOf(files.find(f => { return f.id === this.state.selectedFile.id }));
                files.splice(indexToRemove, 1);
                if (this.state.selectedFile.type.includes('font/')) {
                    let fontName = this.state.selectedFile.name.substring(
                        this.state.selectedFile.name.lastIndexOf('/') + 1,
                        this.state.selectedFile.name.indexOf('.'));
                    this.props.dispatch(cmsActions.removeFont(fontName))
                }
                this.setState({
                    selectedFile: null,
                    files
                })
            })
            .catch(err => {
                console.error(err.message);
            });
    }
    onUploadCropped = (img) => {

        let size = new Buffer(img, 'base64').length / 1000;
        const fileInfo = {
            name: '_cropped_' + securityHelper.createGuid(),
            size: size,
            type: 'image/jpeg',
            file: img
        }
        const requestOptions = {
            method: "POST",
            headers: authHeader({ "Content-Type": "application/json" }),
            body: JSON.stringify(fileInfo)
        };
        this.setState({ uploadingInfo: fileInfo, isUploading: true });

        fetch(`./api/files/` + window.location.search, requestOptions)
            .then(handleResponse)
            .then(file => {
                this.setState({
                    storageUsage: this.state.storageUsage + file.size,
                    selectedFile: Object.assign({}, { ...file }),
                    files: file !== undefined && file !== null && [...this.state.files, Object.assign({}, { ...file })]
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            isUploading: false,
                            uploadingInfo: null,
                            useCropper: false
                        })
                    }, 2500);

                });
            })
            .catch(err => {
                console.error(err.message);
            });
    }
    download = (fileType, all = false) => {
        const requestOptions = {
            method: "GET",
            headers: authHeader({})
        };
        fetch(`./api/files/` + window.location.search, requestOptions)
            .then(response => response.text().then(text => {
                try {
                    const storageSummary = JSON.parse(text);
                    storageSummary.files && storageSummary.files.map((f, i) => {
                        return Object.assign({}, { ...f, key: securityHelper.createGuid() })
                    })
                    if (storageSummary !== null && storageSummary !== undefined) {

                        this.setState({ files: storageSummary.files, storageUsage: storageSummary.eventMemoryUsage });
                    }
                } catch (error) {
                    console.error("DOWNLOAD_ERROR", error)
                }

            }));
    }
    onSelect = (file, unsplash = false) => {
        if (!unsplash) {
            return this.setState({ selectedFile: file })
        }
        else {
            this.setState({ unsplashFile: file })
        }
    }
    filter = (str) => {
        if (!str) {
            return this.setState({
                filtered: []
            });
        }

        const { files } = this.state;

        const filteredFiles = [...files.filter((f, i) => {
            return f.name.includes(str);
        })];

        this.setState({
            filtered: filteredFiles
        });
    }
    crop = (e) => {
        this.setState({ useCropper: true })
    }
    toggleCropper = () => {
        this.setState({ useCropper: !this.state.useCropper })
    }
    render() {
        const {
            files,
            uploadingInfo,
            isUploading,
            showLaunchBtn,
            selectedFile,
            storageUsage,
            display,
            unsplashFile,
            useCropper
        } = this.state;
        return (
            <div>
                {showLaunchBtn && <Button className="launch-btn" onClick={this.toggle}><i className="fa fa-upload" /></Button>}
                <Modal
                    style={{ maxWidth: '1000px', minWidth: '300px', zIndex: 1000 }}
                    isOpen={!showLaunchBtn ? this.props.isOpen : this.state.isOpen}
                    toggle={this.toggle}
                    className="archive-modal-content">
                    <ModalHeader toggle={this.toggle} className="avoid-style-leak">
                        <ErrorBoundary >
                            <ArchiveHeader
                                selectedFile={selectedFile}
                                onUseSelected={this.onUseSelected}
                                onUpload={this.onUpload}
                                onUnsplashDownload={this.onUnsplashDownload}
                                unsplashFile={unsplashFile}
                                crop={this.crop}
                                /*  nav={this.state.d} */
                                fontEnabled={this.state.fontEnabled}
                                onDelete={this.onDeleteFile}
                            />
                        </ErrorBoundary>
                    </ModalHeader>
                    <ModalBody style={{ paddingTop: 0 }} >
                        <Container style={{ padding: '0px', minHeight: '500px', maxHeight: '69vh' }}>
                            <Row>
                                <Col
                                    style={{ padding: 0 }}
                                    className="archive-sidebar"
                                    onClick={() => { this.setState({ selectedFile: null }) }}>
                                    <ErrorBoundary >
                                        <ArchiveSidebar
                                            navigate={this.navigate}
                                            filterType={this.state.filterType}
                                            objects={files} />
                                    </ErrorBoundary>
                                </Col>
                                <Col
                                    className="archive-content">
                                    {isUploading && <UploadingInfo file={uploadingInfo} />}
                                    <ErrorBoundary>
                                        {display === archiveConstants.CLIENT_STORAGE && <ArchiveContent
                                            selectedFile={selectedFile}
                                            onSelect={this.onSelect}
                                            files={files}
                                            filterType={this.state.filterType}
                                            type={archiveConstants.IMAGE} />}
                                        {display === archiveConstants.UNSPLASH && <UnsplashPlugin
                                            onSelect={this.onSelect}
                                            download={this.onUnsplashDownload}
                                            unsplashFile={unsplashFile}
                                        />}

                                    </ErrorBoundary>
                                </Col>
                            </Row>
                        </Container>
                        {selectedFile && useCropper && <ImageCropper cropSizes={this.props.cropSizes || null} url={selectedFile.url} onSave={this.onUploadCropped} close={this.toggleCropper} />}
                    </ModalBody>
                    <ModalFooter>
                        <SystemLabel name="MemoryUsage" />: {storageUsage && Math.round((storageUsage * 0.001) * 10) / 10} {" kB"}
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        cms: state.cms
    };
}
export default connect(mapStateToProps)(ArchiveContainer);


